import moment from "moment";
import { PRIMARY_TEXT_COLOR } from "../../color";
import CustomDataTable from "../../Components/CustomDataTable";
import { genareteColor } from "../../Helper/GenerateStatusColor";
import { useEffect, useState } from "react";
import PostApiCall from "../../Api/Api";
import { useSelector } from "react-redux";
import Notiflix from "notiflix";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import { toast } from "react-toastify";
import { ChevronDown } from "react-feather";

import {
  Button,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Input,
  Label,
  Row
} from "reactstrap";
import CommonModal from "../../Components/CommonModal";
import Select from "react-select";
import { fileConverterHandler } from "../Auditor/helper";
import { delay } from "../../Helper/ToastDelay";
import { imageConverterHandler } from "../../Helper/Converter";

const PaymentRequest = () => {
  const columnDefs = [
    {
      field: "fld_invoiceno",
      header: "Invoice No",
      sortable: true,
      headerStyle: { width: "200px", minWidth: "200px", fontSize: "13px" },
      bodyStyle: { minWidth: "200px", fontSize: "13px" },
    },
    {
      field: "fld_invoicetype",
      header: "Invoice Type",
      sortable: true,
      headerStyle: { width: "200px", minWidth: "200px", fontSize: "13px" },
      bodyStyle: { minWidth: "200px", fontSize: "13px" },
    },
    {
      field: "fld_name",
      header: "Auditor Name",
      sortable: true,
      headerStyle: {
        width: "200px",
        minWidth: "200px",
        fontSize: "13px",
        textTransform: "capitalize",
      },
      bodyStyle: {
        minWidth: "200px",
        fontSize: "13px",
        textTransform: "capitalize",
      },
    },
    {
      field: "fld_invoicedate",
      header: "Invoice Date ",
      sortable: true,
      body: (rowData) =>
        moment(rowData?.fld_invoicedate).format("DD MMM YYYY") || "",
      headerStyle: { width: "250px", fontSize: "13px" },
      bodyStyle: { minWidth: "250px", fontSize: "13px" },
    },
    {
      field: "fld_totalamount",
      header: "Total Amount ",
      sortable: true,
      body: (rowData) => <span>Rs {rowData?.fld_totalamount}</span>,
      headerStyle: { width: "250px", fontSize: "13px" },
      bodyStyle: { minWidth: "250px", fontSize: "13px" },
    },
    {
      field: "PayableAmount",
      header: "Paid Amount ",
      sortable: true,
      body: (rowData) => <span>Rs {rowData?.PayableAmount || 0}</span>,
      headerStyle: { width: "250px", fontSize: "13px" },
      bodyStyle: { minWidth: "250px", fontSize: "13px" },
    },

    {
      field: "fld_invoicestatus",
      header: "Invoice Status",
      sortable: true,
      width: "100px",
      body: (rowData) => (
        <span
          className={`${genareteColor(
            rowData.fld_invoicestatus
          )} font-size-3 rounded-3 px-2`}
        >
          {rowData.fld_invoicestatus}
        </span>
      ),
      headerStyle: { width: "250px", fontSize: "13px" },
      bodyStyle: { minWidth: "250px", fontSize: "13px" },
    },
    {
      field: "action",
      header: "Action",
      sortable: true,
      width: "100px",
      body: (rowData) => (
        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            setAuditAction({
              auditstatus: {
                value: rowData?.fld_invoicestatus,
                label: rowData?.fld_invoicestatus,
              },
              evidence: "",
              invoiceno: rowData?.fld_invoiceno,
              remarks: "",
              totalamt: rowData?.fld_totalamount,
              paid: rowData?.PayableAmount,
              userid: rowData?.fld_userid,
              id: rowData?.fld_id,
            });
            setPaymentStatusModal(true);
          }}
        >
          <Button
            className="btns"
            disabled={rowData?.fld_totalamount == rowData?.PayableAmount}
            style={{
              fontSize: "13px",
              textTransform: "capitalize",
              opacity:
                rowData?.fld_totalamount == rowData?.PayableAmount ? 0.2 : 1,
            }}
          >
            Pay Now
          </Button>
        </div>
      ),
      headerStyle: { width: "100px", fontSize: "13px" },
      bodyStyle: { minWidth: "100px", fontSize: "13px" },
    },
  ];

  const user = useSelector((state) => state.login);
  const [paymentRequest, setPaymentRequest] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [paymentStatusModal, setPaymentStatusModal] = useState(false);
  const [auditAction, setAuditAction] = useState({
    auditstatus: { value: "Pending", label: "Pending" },
    evidence: "",
    invoiceno: "",
    remarks: "",
    totalamt: "",
    payableamt: "",
    mode: "",
    paid: "",
    userid: 0
  });

  const [validationErrors, setValidationErrors] = useState({});
  const [AuditorBank, setAuditorBank] = useState(null)

  const fetchAuditorBankDetails = async (value) => {
    try {
      Notiflix.Loading.standard(); // Show loading indicator

      console.log("vallue", value)

      const res = await PostApiCall.postRequest({ userid: value }, "GetAuditorBankById");
      const json = await res.json();

      Notiflix.Loading.remove(); // Ensure loading is removed after API response

      if (res.ok) {
        toast.success(json.data, {
          autoClose: delay,
        });

        setAuditorBank(json.data[0]);
      } else {
        throw new Error(json.data);
      }
    } catch (error) {
      Notiflix.Loading.remove();
      toast.error(error.message || SomethingWrong, {
        autoClose: delay,
        toastId: 1,
      });
    }
  }

  const validateFields = () => {
    const errors = {};
    if (!auditAction.auditstatus)
      errors.auditstatus = "Payment status is required";
    if (!auditAction.totalamt) errors.totalamt = "Total amount is required";
    if (!auditAction.payableamt)
      errors.payableamt = "Payable amount is required";
    if (!auditAction.evidence) errors.evidence = "Evidence is required";
    if (!auditAction.mode) errors.mode = "Payment mode is required";
    if (!auditAction.remarks) errors.remarks = "Payment remarks are required";
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  useEffect(() => {
    (async () => {
      Notiflix.Loading.standard();
      try {
        const res = await PostApiCall.postRequest(
          { usertype: user?.fld_usertype },
          "GetGenerateInvoice"
        );
        const { data } = await res.json();

        if (res.status == 200) {
          setPaymentRequest(data);
          setRefresh(false);
        } else {
          throw new Error(data.message);
        }
        Notiflix.Loading.remove();
      } catch (error) {
        toast.error(error.message || SomethingWrong, {
          autoClose: delay,
          toastId: 1,
        });
        Notiflix.Loading.remove();
      }
    })();
  }, [refresh]);

  const submitForm = async () => {
    // console.log("auditAction", auditAction);
    // return;
    if (validateFields()) {
      let payload = {
        invoicestatus: auditAction.auditstatus?.value,
        paymentstatus: auditAction.auditstatus?.value,
        invoiceno: auditAction.invoiceno,
        paymentmode: auditAction.mode,
        amount: auditAction.payableamt,
        evidence: auditAction.evidence,
        paymentremarks: auditAction.remarks,
        totalamount: auditAction.totalamt,
      };

      Notiflix.Confirm.init({
        titleColor: '#c16d18', // Title text color
        okButtonBackground: '#c16d18', // Confirm button background color
        cancelButtonBackground: '#a9a9a9', // Cancel button background color
        // Add other custom settings here
      });

      Notiflix.Confirm.show(
        'Payment Confirmation',
        'Are you sure you want to proceed with the payment?',
        'Yes',
        'No',
        async () => {
          // User clicked "Yes", proceed with the API call
          try {
            // Show loading indicator
            Notiflix.Loading.standard();

            const res = await PostApiCall.postRequest(payload, "AuditTransaction");
            const json = await res.json();

            // Ensure loading is removed after API response
            Notiflix.Loading.remove();

            if (res.ok) {
              toast.success(json.data, {
                autoClose: delay,
              });

              setRefresh(true);
            } else {
              throw new Error(json.data);
            }
          } catch (error) {
            Notiflix.Loading.remove();
            toast.error(error.message || 'Something went wrong', {
              autoClose: delay,
              toastId: 1,
            });
          }
          setPaymentStatusModal(false);
        },
        () => {
          // User clicked "No", do nothing
          console.log('Operation cancelled by the user.');
        }
      );
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center flex-wrap mt-4">
        <h5 style={{ color: PRIMARY_TEXT_COLOR }}>Payment Request</h5>
      </div>
      <div className="mt-2" style={{ minHeight: "400px" }}>
        <CustomDataTable
          data={paymentRequest}
          columns={columnDefs}
          compact={true} // Enables compact styling
        />
      </div>

      {paymentStatusModal === true && (
        <CommonModal
          isOpen={paymentStatusModal}
          toggle={() => setPaymentStatusModal(false)}
          heading={"Payment Action"}
          contentBody={
            <Row style={{ marginTop: "0px", zIndex: "50" }}>
              <Col sx="12" md="12">
                <Label>
                  Payment Status <span className="mandatory">*</span>
                </Label>
                <Select
                  placeholder="Select"
                  options={[
                    { value: "Pending", label: "Pending" },
                    { value: "Reviewed", label: "Reviewed" },
                    { value: "Completed", label: "Completed" },
                    { value: "Rejected", label: "Rejected" },
                  ]}
                  onChange={(selectedOption) => {
                    setAuditAction((pre) => ({
                      ...pre,
                      auditstatus: selectedOption,
                    }));
                  }}
                  value={auditAction.auditstatus}
                />
                {validationErrors.auditstatus && (
                  <div className="text-danger">
                    {validationErrors.auditstatus}
                  </div>
                )}
              </Col>

              <Col sx="12" md="6" className="my-2">
                <Label>
                  Total Amount <span className="mandatory">*</span>
                </Label>
                <Input
                  disabled
                  type="number"
                  placeholder="Amount"
                  onChange={(e) => {
                    setAuditAction((pre) => ({
                      ...pre,
                      totalamt: e.target.value,
                    }));
                  }}
                  value={auditAction.totalamt}
                />
                {validationErrors.totalamt && (
                  <div className="text-danger">{validationErrors.totalamt}</div>
                )}
              </Col>

              <Col sx="12" md="6" className="my-2">
                <Label>
                  Paid Amount <span className="mandatory">*</span>
                </Label>
                <Input
                  disabled
                  type="number"
                  placeholder="Amount"
                  value={auditAction.paid || 0}
                />
              </Col>

              <Col sx="12" md="12" className="my-2">
                <Label>
                  Payable Amount <span className="mandatory">*</span>
                </Label>
                <Input
                  type="number"
                  placeholder="Amount"
                  max={auditAction.totalamt - auditAction.paid}
                  onChange={(e) => {
                    setAuditAction((pre) => ({
                      ...pre,
                      payableamt: e.target.value,
                    }));
                    setValidationErrors((pre) => ({
                      ...pre,
                      payableamt: "",
                    }));
                  }}
                  value={auditAction.payableamt}
                />
                {validationErrors.payableamt && (
                  <div className="text-danger">
                    {validationErrors.payableamt}
                  </div>
                )}
              </Col>

              <Col sm="12">
                <Label>
                  Upload Evidence{" "}
                  {auditAction.evidence && (
                    <a
                      href={`${process.env.REACT_APP_FILE_PATH_URL} + ${auditAction.evidence}}`}
                      target="__blank"
                      className="ml-2 text-primary"
                    >
                      ( View )
                    </a>
                  )}
                  <span className="mandatory">*</span>
                </Label>
                <Input
                  type="file"
                  name="evidence"
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    if (file && file.size > 5000000) {
                      Notiflix.Notify.failure(
                        "File too large, upload file less than 5 Mb."
                      );
                      return;
                    }
                    const img = await imageConverterHandler(
                      file,
                      user.fld_id[0],
                      "evidence"
                    );

                    setAuditAction((pre) => ({
                      ...pre,
                      evidence: img,
                    }));
                    setValidationErrors((pre) => ({
                      ...pre,
                      evidence: "",
                    }));
                  }}
                />
                {validationErrors.evidence && (
                  <div className="text-danger">{validationErrors.evidence}</div>
                )}
              </Col>

              <Col sx="12" md="12" className="my-2">
                <Label>
                  Payment Mode <span className="mandatory">*</span>
                </Label>
                <Input
                  type="text"
                  placeholder="Payment mode"
                  value={auditAction.mode}
                  onChange={(e) => {
                    setAuditAction((pre) => ({
                      ...pre,
                      mode: e.target.value,
                    }));
                    setValidationErrors((pre) => ({
                      ...pre,
                      mode: "",
                    }));
                  }}
                />
                {validationErrors.mode && (
                  <div className="text-danger">{validationErrors.mode}</div>
                )}
              </Col>

              <Col sx="12" md="12" className="my-2">
                <Label>
                  Payment Remarks <span className="mandatory">*</span>
                </Label>
                <Input
                  type="textarea"
                  placeholder="Message ..."
                  value={auditAction.remarks}
                  className="w-100 mt-1 pt-2"
                  style={{ height: "100px", paddingLeft: "10px" }}
                  onChange={(e) => {
                    setAuditAction((pre) => ({
                      ...pre,
                      remarks: e.target.value,
                    }));
                    setValidationErrors((pre) => ({
                      ...pre,
                      remarks: "",
                    }));
                  }}
                />
                {validationErrors.remarks && (
                  <div className="text-danger">{validationErrors.remarks}</div>
                )}
              </Col>
              <Col>
                <div>
                  <Button
                    className="basebgColor px-2 py-0 rounded-3 "
                    onClick={() => fetchAuditorBankDetails(auditAction.userid)}
                  >
                    <span style={{ fontSize: "12px" }}>View Auditor Bank</span>
                    {/* <ChevronDown /> */}
                  </Button>
                </div>
              </Col>
              {/* Bank Details Page */}
              {AuditorBank && (
                <Col xs="12" md="12" className="my-3">
                  {
                    console.log("sa.dlijaoidnwoiahndoiwnoin")
                  }
                  <Card className="shadow-sm">
                    <CardBody>
                      <Row>
                        <Col md="6" className="mb-3">
                          <CardText className="fs-6">
                            <strong>Account Number:</strong> {AuditorBank.fld_accountno}
                          </CardText>
                        </Col>

                        <Col md="6" className="mb-3">
                          <CardText className="fs-6">
                            <strong>Account Holder:</strong> {AuditorBank.fld_holdername.toUpperCase()}
                          </CardText>
                        </Col>

                        <Col md="6" className="mb-3">
                          <CardText className="fs-6">
                            <strong>Bank Name:</strong> {AuditorBank.fld_bankname}
                          </CardText>
                        </Col>

                        <Col md="6" className="mb-3">
                          <CardText className="fs-6">
                            <strong>IFSC Code:</strong> {AuditorBank.fld_ifsccode}
                          </CardText>
                        </Col>

                        <Col md="6" className="mb-3">
                          <CardText className="fs-6">
                            <strong>Bank City:</strong> {AuditorBank.fld_bankcity}
                          </CardText>
                        </Col>

                        <Col md="6" className="mb-3">
                          <CardText className="fs-6">
                            <strong>Bank State:</strong> {AuditorBank.fld_bankstate}
                          </CardText>
                        </Col>

                        <Col md="12">
                          <CardText className="fs-6">
                            <strong>UPI ID:</strong> {AuditorBank.fld_upi || 'N/A'}
                          </CardText>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              ) }
              <Col>
              </Col>
            </Row>
          }
          onConfirm={submitForm}
          confirmText={"submit"}
          // acceptText={<Check size={15} />}
          // rejectText={<X size={15} />}
          cancelText={"Cancel"}
          onCancel={() => setPaymentStatusModal(false)}
        />
      )}
    </div>
  );
};

export default PaymentRequest;
